import {BaseOptions} from "../../options/base.options";

export class MaintenanceOptions extends BaseOptions {
  onResolved = () => {
  };
}
